import { Produktlinienname } from '@ps20/bff-models';
import { Produktline } from './9_migrate_versSummen.interface';
import { StatePreV10, StateV10 } from './10_migrate_selectedWertsachensumme.interface';

export const migrateProduktnameToEnumSelectedWertsachensumme = (
  previousState: StatePreV10,
  newVersion: number,
): StateV10 => {
  let selectedWertsachensumme = null;
  if (previousState.selectedWertsachensumme) {
    selectedWertsachensumme = {
      ...previousState.selectedWertsachensumme,
      produktline: mapToProduktname(previousState.selectedWertsachensumme.produktline),
    };
  }
  return {
    ...previousState,
    version: newVersion,
    selectedWertsachensumme,
  };
};

export function mapToProduktname(produktlinie: Produktline): Produktlinienname {
  let productName: Produktlinienname;
  switch (produktlinie) {
    case Produktline.S:
      productName = Produktlinienname.BASIS;
      break;
    case Produktline.M:
      productName = Produktlinienname.SMART;
      break;
    case Produktline.L:
      productName = Produktlinienname.KOMFORT;
      break;
    case Produktline.XL:
      productName = Produktlinienname.PREMIUM;
      break;
    default:
      productName = produktlinie as Produktlinienname;
      break;
  }
  return productName;
}
